
import React ,{ Component } from 'react';
import {Container, Row, Col,Button,Image,Form,OverlayTrigger,Tooltip } from 'react-bootstrap';
import "./EventsAndActivities.css";
import arrowLeft from '../../images/arrow-left.png';
import { withRouter,Link } from "react-router-dom";
import { getCampaignAPICallData } from '../../services/MemberService';
import loader from '../../images/loader.gif';
import CardLessDataTableWithOutSearch from '../datatables/CardLessDataTableWithOutSearch';
import UpdateMLCD2D1VisitedAttributesSavingModal from './UpdateMLCD2D1VisitedAttributesSavingModal';
import { getAPICallData } from '../../services/MemberService';
import { getAPICallDataForOnlyBSA } from '../../services/MemberService'

class MLCVotersD2D1Visited extends Component {
  constructor(props) {
      super(props)
      this.state = {

        userAccessList:props?.location?.params?.userAccessList == undefined ? "" : props?.location?.params?.userAccessList,
        event:props?.location?.params?.event == undefined ? "" : props?.location?.params?.event,
        eventStatus:props?.location?.params?.eventStatus == undefined ? "" : props?.location?.params?.eventStatus,
        campaignDetailsId:props?.location?.params?.campaignDetailsId == undefined ? "" : props?.location?.params?.campaignDetailsId,
        eventType:props?.location?.params?.eventType == undefined ? "" : props?.location?.params?.eventType,
        isAttended:props?.location?.params?.isAttended == undefined ? "" : props?.location?.params?.isAttended,
        surveyType:props?.location?.params?.surveyType == undefined ? "" : props?.location?.params?.surveyType,
        pollManagementPage:props?.location?.params?.pollManagementPage == undefined ? "" : props?.location?.params?.pollManagementPage,
        MLCPage:props?.location?.params?.MLCPage == undefined ? "" : props?.location?.params?.MLCPage,

        MLC_booth_boolean:true,
        mandal_view_boolean:false,

        MLCvoterType:"Mlc_booth",

        MLC_MandalNames:[],
        validateReason:"",

        villageCheckLoader:0,
        MLC_VillageNames:[],
        validateReasonForVillage:"",

        MLC_BoothLoc:[],
        validateReasonMLCBoothLoc:0,

        streetCheckLoader:0,
        MLC_StreetNames:[],
        streetCheckMessage:0,

        statusTypeVoter:"",

        MLCVotersListData:[],
        MLCVotersListCheck:1,
        MLCVotersListCheckLoderSymbol:"hide",
        votersListCheck:0,

        updateMLCVoterAttributesModal:false,
        updateVoterId:"",
        updateVoterDetails:{},
        updateVoterCardNo:"",
        transportStatus:"",
        caste:"",
        party:"",
        mobileNo:"",
        validateUpdateMobileNo:"",
        validateUpdateParty:"",
        validateUpdateCaste:"",
        validateUpdateTransportStatus:"",
        validateUpdateVoterCardNo:"",
        newMemberAddedMsg:"",
        voterSlipGiven:"",
        demoBalletGiven:"",
        validateUpdateVoterSlipGiven:"",
        validateUpdateDemoBalletGiven:"",
        visitLoaderSymbol:"hide",
        MLCBoothLocName:"",
        validateUpdateVoterStatus:"",
        voterStatus:"",

        searchVoterDataValue:"",
        voterDateBlockShow:false,

        MLCBoothWiseSummaryListData:[],
        mlcBoothWiseSummaryStatusObj:{},
        totalVoterDetails:[],

        searchValue: "",
        showDropdown: false,
        selectedOption: "",
        options: [{'id':228, 'name':'Aandh '},{'id':326, 'name':'AASADULA '},
          {'id':75, 'name':'Achukuntla Vandlu '},{'id':312, 'name':'Adi Dravida '},{'id':224, 'name':'AdiAndhra '},{'id':461, 'name':'Agamudayar '},{'id':309, 'name':'Agamudi Mudaliar '},{'id':121, 'name':'Agaru '},{'id':1, 'name':'Agnikula kshathriya '},{'id':199, 'name':'Anamakh '},{'id':200, 'name':'Andhravida '},{'id':122, 'name':'Arae '},{'id':388, 'name':'Arakalies and Surabi natakalavallu '},
          {'id':201, 'name':'Arapamala '},{'id':347, 'name':'Arava '},{'id':387, 'name':'Are Marathi '},{'id':123, 'name':'Arekatika '},
          {'id':202, 'name':'Aremala '},{'id':177, 'name':'Arundatheeya '},{'id':329, 'name':'Arwa Mala '},{'id':76, 'name':'Arya Kshathrya '},{'id':124, 'name':'Atagara '},{'id':397, 'name':'Atirasa '},{'id':77, 'name':'Avusala '},
          {'id':396, 'name':'Ayyaraka '},{'id':2, 'name':'Badar '},{'id':229, 'name':'Bagatha '},{'id':3, 'name':'Balasanthu '},{'id':296, 'name':'Balija '},{'id':467, 'name':'Balija Kapu '},{'id':4, 'name':'Banda '},{'id':5, 'name':'Bandara '},{'id':353, 'name':'Banjara '},{'id':230, 'name':'Barhika Duliya '},{'id':203, 'name':'Barigi '},{'id':125, 'name':'Batraju '},{'id':162, 'name':'Bavuri '},
          {'id':120, 'name':'BC - C (Cristians) '},{'id':178, 'name':'Bedajangam '},{'id':204, 'name':'Begara '},{'id':442, 'name':'Behar '},{'id':179, 'name':'Bendla '},
          {'id':449, 'name':'Bengali '},{'id':342, 'name':'Beri Sheety '},{'id':6, 'name':'Bestha '},{'id':391, 'name':'Bhadbhunja '},{'id':7, 'name':'Bhahurupi '},{'id':390, 'name':'Bhunjwa '},{'id':8, 'name':'Bikshaka Vruthi '},{'id':439, 'name':'Biksham Gunta '},{'id':231, 'name':'Bil '},{'id':403, 'name':'Bindla '},{'id':331, 'name':'Binedu '},{'id':416, 'name':'Bodo Gadaba '},{'id':306, 'name':'Bondili '},{'id':293, 'name':'Boya '},{'id':284, 'name':'Brahmin '},{'id':9, 'name':'Buda Bukkala '},{'id':180, 'name':'Budaga Jangam '},{'id':389, 'name':'Budubunjala '},{'id':126, 'name':'Bukka '},{'id':354, 'name':'Bukka Ayyavara '},{'id':404, 'name':'Byagara '},{'id':405, 'name':'Chachati '},{'id':444, 'name':'Chacherlu '},{'id':406, 'name':'Chalavadi '},{'id':205, 'name':'Challavadi '},{'id':181, 'name':'Chamar '},{'id':182, 'name':'Chambar '},{'id':410, 'name':'Chanchandi '},{'id':164, 'name':'Chandala '},{'id':163, 'name':'Chavati '},{'id':232, 'name':'Chenchu Varu '},{'id':233, 'name':'Chenchumuni '},{'id':127, 'name':'Chimpollu '},{'id':78, 'name':'Chithari '},
          {'id':79, 'name':'Chithrakara '},{'id':445, 'name':'Chitti Karanam '},{'id':11, 'name':'Chopamali '},{'id':459, 'name':'Christian '},{'id':470, 'name':'Converted Harijans '},{'id':183, 'name':'Dakkal/Dakkala Varu '},{'id':355, 'name':'Damala '},{'id':165, 'name':'Dandasi '},{'id':12, 'name':'Dasari (BC-A) '},{'id':128, 'name':'Dasari (BC-D) '},{'id':234, 'name':'Deseeya kondulu '},{'id':235, 'name':'Desiya Dondulu '},{'id':80, 'name':'Devanga '},{'id':13, 'name':'Devara Vandlu '},{'id':184, 'name':'Dhor '},{'id':423, 'name':'Dhulia '},{'id':167, 'name':'DomDombara '},{'id':14, 'name':'Dommara '},{'id':236, 'name':'Dondra Kodulu '},{'id':81, 'name':'Dudekula '},{'id':82, 'name':'Ediga '},{'id':321, 'name':'EKILA '},{'id':352, 'name':'Ekiri '},{'id':15, 'name':'Ellamma Vandlu '},{'id':16, 'name':'Ellasi '},{'id':345, 'name':'Erla '},{'id':237, 'name':'Gadabalu '},{'id':415, 'name':'Gadabas '},{'id':129, 'name':'Gadava '},{'id':318, 'name':'Gajula Balija '},{'id':83, 'name':'Gamalla Kalali '},{'id':84, 'name':'Gandla '},{'id':18, 'name':'Ganga Varu '},{'id':17, 'name':'Gangaputhra '},{'id':19, 'name':'Gangireddu Varu '},{'id':340, 'name':'Ganuga Sheety '},{'id':168, 'name':'Gasi '},{'id':130, 'name':'Gavara '},{'id':407, 'name':'Ghasi '},{'id':131, 'name':'Ginghar '},{'id':85, 'name':'Giniyar '},{'id':170, 'name':'Godagali '},{'id':185, 'name':'Godari '},{'id':20, 'name':'Gondlu '},{'id':238, 'name':'Gondu '},{'id':206, 'name':'Gosam '},{'id':411, 'name':'Gosangi '},{'id':357, 'name':'Gotrala '},{'id':239, 'name':'Goud-ST '},{'id':86, 'name':'Gouda '},{'id':240, 'name':'Goudh '},{'id':87, 'name':'Goundla '},{'id':21, 'name':'Gudala '},{'id':392, 'name':'Gudia '},{'id':393, 'name':'Gudiya '},{'id':417, 'name':'Gutob Gadaba '},{'id':408, 'name':'Haddi '},
          {'id':169, 'name':'Haddi (or) Relli chachandi '},{'id':446, 'name':'Harijans '},{'id':132, 'name':'Hatkhar '},{'id':419, 'name':'Hill Reddis '},{'id':207, 'name':'Huleya '},{'id':208, 'name':'Huleya Dasari '},{'id':186, 'name':'Jaggali '},{'id':412, 'name':'JaJnbllvulu '},{'id':332, 'name':'Jakkula '},{'id':22, 'name':'Jalari '},
          {'id':187, 'name':'Jambavulu '},{'id':88, 'name':'Jandra '},{'id':23, 'name':'Jangam '},{'id':241, 'name':'Jathapass '},{'id':24, 'name':'Jogi '},{'id':341, 'name':'Jogula '},{'id':25, 'name':'Joshinandala Bala '},{'id':133, 'name':'Kachi '},{'id':26, 'name':'Kaikadi '},{'id':89, 'name':'Kaikala '},{'id':438, 'name':'Kaitha Lambadi(Labhana) '},
          {'id':134, 'name':'Kakkana '},{'id':335, 'name':'Kalai Balija '},{'id':135, 'name':'Kalavanthulu Ganika '},{'id':324, 'name':'KALINGA '},{'id':440, 'name':'Kalinga Vysya '},{'id':418, 'name':'kallayi gadaba '},{'id':27, 'name':'Kalli Kapu '},{'id':290, 'name':'Kamma '},{'id':90, 'name':'Kammara (BC) '},{'id':242, 'name':'Kammara (ST) '},{'id':91, 'name':'Kamsali/Vishva Bramhana '},{'id':92, 'name':'Kanchra '},{'id':136, 'name':'Kandhra '},{'id':28, 'name':'Kanjara Battu '},{'id':288, 'name':'Kapu '},{'id':466, 'name':'Kapu Kapu '},{'id':469, 'name':'Kapu-ST '},{'id':304, 'name':'KARANAM '},{'id':323, 'name':'KARIKALABHAKTHULA '},{'id':93, 'name':'Karna Bakthulu '},{'id':322, 'name':'KARNABHAKTHULA '},{'id':358, 'name':'Kasikapadi '},{'id':94, 'name':'Kathri '},{'id':29, 'name':'Kati Papala '},{'id':243, 'name':'Katunaikan '},{'id':333, 'name':'Kavali '},{'id':431, 'name':'Kerala '},{'id':359, 'name':'Keuta '},{'id':360, 'name':'Keviti '},{'id':361, 'name':'Kevuto '},{'id':30, 'name':'Kinthala Kalinga '},{'id':31, 'name':'Kirathaka '},{'id':244, 'name':'Kodhu '},{'id':245, 'name':'Kodi '},{'id':420, 'name':'Kolam '},{'id':421, 'name':'Kolawar '},{'id':188, 'name':'Koluvula Vandlu '},{'id':32, 'name':'Kompara/Reddika '},{'id':246, 'name':'Konda Doralu '},{'id':247, 'name':'Konda Kapulu '},{'id':248, 'name':'Konda Reddlu '},{'id':250, 'name':'Kondlu '},{'id':137, 'name':'Koppula Velama '},{'id':251, 'name':'Koputiya '},{'id':252, 'name':'Koram '},{'id':33, 'name':'Korcha '},{'id':138, 'name':'Kosti '},{'id':433, 'name':'Kotiya '},{'id':253, 'name':'Kotiya Benthu '},{'id':254, 'name':'Koya '},{'id':139, 'name':'Krushna Balija '},{'id':34, 'name':'Kshathriya (BC) '},{'id':291, 'name':'Kshatriya (OC) '},{'id':255, 'name':'Kuliya '},{'id':256, 'name':'Kulwalapai '},{'id':95, 'name':'Kummara '},{'id':35, 'name':'Kunapuli '},{'id':429, 'name':'Kunkuma '},{'id':475, 'name':'Kuraba '},{'id':362, 'name':'Kurakala '},{'id':382, 'name':'Kurni '},
          {'id':96, 'name':'Kuruma '},{'id':257, 'name':'Kuttiya Kodulu '},{'id':317, 'name':'Labbai '},{'id':97, 'name':'Laddaf '},{'id':402, 'name':'Lakkamari Kapu '},{'id':363, 'name':'Lambada '},{'id':258, 'name':'Lambadi '},{'id':313, 'name':'Lingayat '},{'id':384, 'name':'Lodh '},{'id':386, 'name':'Lodha '},{'id':385, 'name':'Lodhi '},{'id':189, 'name':'Madiga '},{'id':190, 'name':'Madiga Dasu '},{'id':209, 'name':'Madisi Kuruva/Madaari Kuruva '},{'id':210, 'name':'Mahar '},{'id':36, 'name':'Mahathar '},{'id':211, 'name':'Mala '},{'id':212, 'name':'Mala Dasari '},{'id':213, 'name':'Mala Hannai '},{'id':214, 'name':'Mala Jangam '},{'id':216, 'name':'Mala Masthi '},{'id':217, 'name':'Mala Sala '},{'id':218, 'name':'Mala sanyasi '},{'id':427, 'name':'Maladasu '},{'id':140, 'name':'Mali '},{'id':259, 'name':'Malin '},{'id':37, 'name':'Mandala (BC) '},{'id':219, 'name':'Mandala (SC) '},{'id':364, 'name':'Mandula '},{'id':191, 'name':'Mang Garodi '},{'id':192, 'name':'Manga '},{'id':260, 'name':'Manna Dora '},{'id':220, 'name':'Manne '},{'id':448, 'name':'Mannepu '},{'id':261, 'name':'Mannevaru '},{'id':315, 'name':'MARATI '},{'id':330, 'name':'MARWADI '},{'id':225, 'name':'Masthi '},{'id':193, 'name':'Masthima '},{'id':194, 'name':'Mathangi '},{'id':262, 'name':'Mathaya Vavaras (or) Kuttu Vavaras '},{'id':141, 'name':'Mathula '},{'id':305, 'name':'MAYDARA '},{'id':39, 'name':'Medari '},{'id':171, 'name':'Mehthar '},{'id':319, 'name':'Mera Darji '},{'id':226, 'name':'Mitha Iyala Varu '},{'id':195, 'name':'Mochi '},{'id':301, 'name':'Mohamad '},{'id':40, 'name':'Mondi Banda '},{'id':41, 'name':'Mondi Varu '},{'id':42, 'name':'Mondipatta '},{'id':196, 'name':'Moochi '},{'id':98, 'name':'Muchi '},{'id':460, 'name':'Mudaliar '},{'id':143, 'name':'Mudhiraj '},{'id':263, 'name':'Muka Dora '},{'id':314, 'name':'MUNDALA '},{'id':144, 'name':'Munnoor Kapu '},{'id':292, 'name':'Muslim '},{'id':145, 'name':'Mutharasi '},{'id':43, 'name':'Muthyalamma Vandlu '},{'id':428, 'name':'Myralu '},{'id':451, 'name':'N/A '},{'id':348, 'name':'Nadar '},{'id':435, 'name':'Nagaralu '},{'id':99, 'name':'Nagavaddilu '},{'id':146, 'name':'Nagavamsha '},{'id':147, 'name':'Nagavasam '},{'id':264, 'name':'Naik '},{'id':265, 'name':'Naikpoth '},{'id':100, 'name':'Nakhan '},{'id':44, 'name':'Nakkala '},{'id':349, 'name':'Nambi '},
          {'id':45, 'name':'Nashadi '},{'id':101, 'name':'Nashni/Kurni '},{'id':307, 'name':'Natari '},{'id':426, 'name':'Nayaka '},{'id':344, 'name':'Nayani Varu '},{'id':365, 'name':'Nayanivaru '},{'id':38, 'name':'Nayee Brahmin '},{'id':47, 'name':'Nayyala '},{'id':102, 'name':'Neelikanti '},{'id':148, 'name':'Nelli '},{'id':325, 'name':'NEPALI '},{'id':48, 'name':'Nera Pravruthi Kalavaru '},{'id':49, 'name':'Nershakari '},{'id':381, 'name':'Nessi '},{'id':447, 'name':'Nethekani '},{'id':50, 'name':'Nokkara '},{'id':432, 'name':'Nooka Dora '},{'id':298, 'name':'Oreganti Reddy '},{'id':458, 'name':'OTHERS '},{'id':472, 'name':'OTHERS-BC '},{'id':471, 'name':'OTHERS-OC '},{'id':473, 'name':'OTHERS-SC '},{'id':474, 'name':'OTHERS-ST '},{'id':103, 'name':'Padmashali '},{'id':166, 'name':'Paidi/pano '},
          {'id':424, 'name':'Paiko '},{'id':172, 'name':'Paki (or) Mothi '},{'id':366, 'name':'Pala Ekari '},{'id':367, 'name':'Palegaru '},{'id':300, 'name':'Pallepu Kapu '},{'id':310, 'name':'Palli '},{'id':343, 'name':'Palli Kapu '},{'id':346, 'name':'Palli Reddy '},{'id':51, 'name':'Pambala '},{'id':174, 'name':'Pamidi '},{'id':52, 'name':'Pamula '},{'id':227, 'name':'Panchama (or) Pariyuhi '},{'id':450, 'name':'Panda '},{'id':150, 'name':'Panjari '},{'id':53, 'name':'Pannari '},{'id':266, 'name':'Parangi Parcha '},{'id':422, 'name':'Pardhan '},{'id':54, 'name':'Parthi '},{'id':151, 'name':'Paspi '},{'id':395, 'name':'Passi '},{'id':303, 'name':'Pathan '},{'id':104, 'name':'Patkhar '},{'id':55, 'name':'Patlavu '},{'id':436, 'name':'Patnayak '},{'id':434, 'name':'Patnayak '},{'id':316, 'name':'PATRA '},{'id':299, 'name':'Pattapu '},{'id':454, 'name':'Pattusali '},{'id':56, 'name':'Peddaboya '},{'id':57, 'name':'Peddama Vandlu '},{'id':105, 'name':'Perika '},{'id':106, 'name':'Perika Balija '},{'id':107, 'name':'Pinjari/Noorbash '},{'id':59, 'name':'Piriki Muggula '},{'id':58, 'name':'Pitchiguntla '},{'id':152, 'name':'Polinati Velama '},{'id':368, 'name':'Pondara '},{'id':153, 'name':'Poosala '},{'id':369, 'name':'Poosala '},{'id':267, 'name':'Porja '},{'id':60, 'name':'Porvam Bikshaka Vruthi '},{'id':462, 'name':'Pusala '},{'id':425, 'name':'Putiya '},{'id':61, 'name':'Rajaka '},{'id':370, 'name':'Rajannala '},{'id':334, 'name':'Rajput '},{'id':289, 'name':'Raju '},{'id':268, 'name':'Rajugondu '},{'id':154, 'name':'Rangaraju/Bhavasara Kshatriya '},
          {'id':441, 'name':'Ravula '},{'id':476, 'name':'Reddika '},{'id':285, 'name':'Reddy '},{'id':269, 'name':'Reddy Dora '},{'id':465, 'name':'Reddy Kapu '},{'id':468, 'name':'Reddy Reddy '},{'id':175, 'name':'Relli '},{'id':270, 'name':'Rona Rena '},{'id':443, 'name':'Sabeerlu '},{'id':452, 'name':'Sadara '},{'id':155, 'name':'Sadushetti '},{'id':371, 'name':'Saikalgar '},{'id':108, 'name':'Sakulasali '},{'id':197, 'name':'Samagara '},{'id':372, 'name':'Samanthula '},{'id':221, 'name':'Samband '},{'id':222, 'name':'Sambas '},{'id':271, 'name':'Sandrona '},{'id':109, 'name':'Sangundam '},{'id':176, 'name':'Sapru '},{'id':272, 'name':'Sardhan '},{'id':156, 'name':'Sathani '},{'id':273, 'name':'Savaras Kapusavaras '},{'id':311, 'name':'Seervi '},{'id':110, 'name':'Settibalija '},{'id':111, 'name':'Shilpi '},{'id':373, 'name':'Siddula '},{'id':274, 'name':'Sidopaiko '},{'id':430, 'name':'Sikh '},{'id':374, 'name':'Sikligar '},{'id':383, 'name':'Silpis viswakarma '},{'id':198, 'name':'Sindollu '},{'id':351, 'name':'Singh '},{'id':401, 'name':'Sistakaranam '},{'id':398, 'name':'sondi '},{'id':375, 'name':'Sountia '},{'id':112, 'name':'Sri Sayan '},{'id':275, 'name':'Sugaleelu '},{'id':399, 'name':'sundi '},{'id':394, 'name':'Surya Balija '},{'id':339, 'name':'Suryavamsha Rajulu '},{'id':302, 'name':'Syed '},{'id':328, 'name':'Telaga '},{'id':350, 'name':'Telikula '},{'id':113, 'name':'Telugu Matlade Varu '},{'id':114, 'name':'Thalikula '},{'id':157, 'name':'Thammali '},{'id':158, 'name':'Thenugollu '},{'id':276, 'name':'Thikakariya Kodulu '},{'id':115, 'name':'Thogati Thogata '},{'id':173, 'name':'Thoti (BC) '},{'id':277, 'name':'Thoti (ST) '},{'id':159, 'name':'Thurapu Kapu/Gajula Kapu '},{'id':376, 'name':'Tolagari '},{'id':160, 'name':'Uppara/Sankara '},{'id':338, 'name':'Uppu vadde '},{'id':377, 'name':'Vadabalija '},{'id':283, 'name':'Vaddera '},{'id':62, 'name':'Vaddi '},{'id':63, 'name':'Vaddolu '},{'id':116, 'name':'Vadla '},{'id':117, 'name':'Vadra '},{'id':118, 'name':'Vadrangi '},{'id':64, 'name':'Valli '},{'id':65, 'name':'Valli Reddy '},{'id':414, 'name':'Valluvan '},{'id':278, 'name':'Valmiki '},{'id':378, 'name':'Valmiki '},{'id':66, 'name':'Valmiki Boya '},{'id':455, 'name':'Vamsharaj '},{'id':437, 'name':'Vanjari '},{'id':67, 'name':'Vanne Kapu '},{'id':68, 'name':'Vanne Reddy '},{'id':336, 'name':'Vannekapu '},{'id':308, 'name':'Vanyakulakshatriya '},{'id':400, 'name':'varala '},{'id':69, 'name':'Vatti Kothala '},{'id':70, 'name':'Vedabaliga '},
          {'id':379, 'name':'Veerabhadreeya '},{'id':327, 'name':'Veerashaiva LingayatLingabalija '},{'id':287, 'name':'Velama '},{'id':71, 'name':'Venka Kula '},{'id':72, 'name':'Vera Musti '},{'id':73, 'name':'Vodde Yeddelu '},{'id':453, 'name':'Vokkaliga '},{'id':279, 'name':'Voriya/bentu Voriya '},{'id':380, 'name':'Vyakula '},{'id':286, 'name':'Vysya '},{'id':161, 'name':'Yadava '},{'id':337, 'name':'Yalam Reddy '},{'id':74, 'name':'Yata '},{'id':413, 'name':'Yatala '},{'id':223, 'name':'Yellimal Varu '},{'id':280, 'name':'Yenadi '},{'id':281, 'name':'Yerukala '},{'id':282, 'name':'Yoniti Kodulu'}],

          mlcBoothAccessChecking:true,
          d2d1VisitedStateValue:"",
          validateUpdateD2d1VisitedStateValue:"",
          getCurrentLocationCoordinates:{},
          mlcBoothLocLoadingSymbol:"hide",
          updateMLCDTDAttriLoadingSymbol:"hide",
          residenceStatusValue:"",
          voterResidenceAddressVal:"",
          validateResidenceStatusValue:"",
          validateVerResidenceAddressVal:"",
          locationStatus: "Checking Mobile Location Is Enabled or Disabled...",
          checkNexttimeUpdate:""

      }
      this.locationTimeout = null;

      
  }

  componentDidMount() {
    if(this.state.userAccessList == "" || this.state.campaignId == ""){
      this.props.history.push("/dashboard");
    }else{
      //clearTimeout(this.locationTimeout);
      this.checkMobileLocation();
      this.getUserAccessMlcBooths();
    }


   

   
  }

  checkMobileLocation = async () => {
    console.log("sssssssscccccccccc",this.state.locationTimeout)
    if (!navigator.geolocation) {
      this.setState({ locationStatus: "Geolocation is not supported by your browser." });
      return;
    }

    try {
      // Step 1: Check permission status
      if (navigator.permissions) {
        const permission = await navigator.permissions.query({ name: "geolocation" });

        if (permission.state === "denied") {
          this.setState({ locationStatus: "Location is OFF ❌ (Permission Denied). Enable location services." });
          return;
        }
      }

      console.log("sssssssscccccccccc1",this.state.locationTimeout)

      // Step 2: Set a timeout to detect if location is OFF (e.g., GPS disabled)
      this.locationTimeout = setTimeout(() => {
        this.setState({ locationStatus: "Location is OFF ❌ (GPS Disabled). Please turn it ON." });
      }, 6000); // Timeout after 5 seconds if no response

      // Step 3: Request location
      navigator.geolocation.getCurrentPosition(
        (position) => {
          

          clearTimeout(this.locationTimeout); // Clear timeout if we get a response
          this.setState({ locationStatus: "Location is ON" });

          console.log("sssssssscccccccccc2",this.state.locationTimeout)
          const getCoordinatesdd =  
          { 
            "latitude" : position.coords.latitude,
            "longitude" : position.coords.longitude,
          }
          
          this.setState({getCurrentLocationCoordinates:getCoordinatesdd});

        },
        (error) => {
          clearTimeout(this.locationTimeout); // Clear timeout since we got an error
          console.log("sssssssscccccccccc3",this.state.locationTimeout)

          let errorMessage = "An unknown error occurred.";
          switch (error.code) {
            case error.PERMISSION_DENIED:
              errorMessage = "Location is OFF ❌ (Access Denied). Please enable location services.";
              break;
            case error.POSITION_UNAVAILABLE:
              errorMessage = "Location is OFF ❌ (Position Unavailable). Turn on GPS.";
              break;
            case error.TIMEOUT:
              errorMessage = "The request to get user location timed out,Please Close The BOT Then Reopen...";
              break;
            default:
              break;
          }
          this.setState({ locationStatus: errorMessage });
        },
        { timeout: 5000 } // Ensure the request times out if it hangs
      );
    } catch (error) {
      this.setState({ locationStatus: "Error checking location status." });
    }
  };

  selectStatusType = (statusType,value) => {
    this.setState({
      MLCvoterType:"Mlc_booth",

        MLC_MandalNames:[],
        validateReason:"",

        villageCheckLoader:0,
        MLC_VillageNames:[],
        validateReasonForVillage:"",

        MLC_BoothLoc:[],
        validateReasonMLCBoothLoc:0,

        streetCheckLoader:0,
        MLC_StreetNames:[],
        streetCheckMessage:0,
        voterDateBlockShow:false
    });

    this.setState({MLCVotersListData:[]});
              
    this.setState({statusTypeVoter:value});

    this.setState({ MLC_booth_boolean:true,mandal_view_boolean:false})
      

    this.getMandalTownsByUserAccess();
    this.getMlcBoothsInAssemblyConstituency();

  }

  selectedVoterType = (value) => {
    this.setState({MLC_BoothLoc:[],voterDateBlockShow:false});
    if(value == "Mlc_booth"){
      this.setState({ MLC_booth_boolean:true,mandal_view_boolean:false})
    }else{
      this.setState({ MLC_booth_boolean:false,mandal_view_boolean:true})
    }
    this.setState({MLCvoterType:value});

    

    if(value == "Mlc_booth"){
      this.getUserAccessMlcBooths();
    }else{
      this.getMandalTownsByUserAccess();
      this.getMlcBoothsInAssemblyConstituency();
    }
    

  }

  getUserAccessMlcBooths = () => {
    this.setState({mlcBoothLocLoadingSymbol:"show"})
    // this.setState({MLC_clusterNames:[],MLC_unitNames:[],MLC_boothList:[]});
    const userAccessObj =  
      JSON.stringify({ 
          "chatId" :window.User !=undefined ? window.User.chatID : "943827154",
          
      });
        
        getAPICallDataForOnlyBSA(userAccessObj,"getUserAccessMlcBooths")
        .then((res) => res.json())
        .then((data) => { 
            this.setState({mlcBoothLocLoadingSymbol:"hide"})
            if(data !=null && data.length>0){
              this.setState({MLC_BoothLoc:data,mlcBoothAccessChecking:true});
             
            }else{
              this.setState({MLC_BoothLoc:data,mlcBoothAccessChecking:true});
              this.getMandalTownsByUserAccess();
              this.getMlcBoothsInAssemblyConstituency();
            }
            
        });
  }

  getMlcBoothsInAssemblyConstituency = () => {
    this.setState({mlcBoothLocLoadingSymbol:"show"})
    // this.setState({MLC_clusterNames:[],MLC_unitNames:[],MLC_boothList:[]});
        const userAccessObj =  
        JSON.stringify({ 
            "chatId" :window.User !=undefined ? window.User.chatID : "943827154",
            
        });
        

    getCampaignAPICallData(userAccessObj,"getMlcBoothsInAssemblyConstituency")
        .then((res) => res.json())
        .then((data) => { 
          this.setState({mlcBoothLocLoadingSymbol:"hide"})
            if(data !=null && data.length>0){
                this.setState({MLC_BoothLoc:data});
            }else{
                this.setState({MLC_BoothLoc:[]});
            }
            
        });
  }

  getMandalTownsByUserAccess = () => {
    this.setState({mlcBoothLocLoadingSymbol:"show"})
    this.setState({MLC_MandalNames:[],MLC_StreetNames:[],MLC_VillageNames:[]});
    const userAccessObj =  
        JSON.stringify({ 
            "chatId" :window.User !=undefined ? window.User.chatID : "943827154",
            
        });
         

    getCampaignAPICallData(userAccessObj,"getMandalTownsByUserAccess")
        .then((res) => res.json())
        .then((data) => { 
          this.setState({mlcBoothLocLoadingSymbol:"hide"})
          if(data !=null && data.length>0){
            this.setState({MLC_MandalNames:data});
          }else{
              this.setState({MLC_MandalNames:[]});
          }
            
         });
  }

  getVillagesForMLCVoters = (locationScopeId,locationId) => {
    this.setState({MLC_VillageNames:[]});
    this.setState({villageCheckLoader:1});
    const userAccessObj =  
        JSON.stringify({ 
            "chatId" :window.User !=undefined ? window.User.chatID : "943827154",
            "locationScopeId" : locationScopeId,
            "locationId" : parseInt(locationId)
            
        });
         

    getCampaignAPICallData(userAccessObj,"getVillagesForMLCVoters")
        .then((res) => res.json())
        .then((data) => { 
          if(data !=null && data.length>0){
            this.setState({MLC_VillageNames:data,villageCheckLoader:0});
          }else{
              this.setState({MLC_VillageNames:[],villageCheckLoader:0});
          }
            
         });
  }
  
  getStreetsForMLCVoters = (locationScopeId,villageName) => {
    this.setState({MLC_StreetNames:[]});
    this.setState({streetCheckLoader:1});
    const userAccessObj =  
        JSON.stringify({ 
            "chatId" :window.User !=undefined ? window.User.chatID : "943827154",
            "locationScopeId" : locationScopeId,
            "locationId" : this.state.mandalId,
            "village" : villageName.replace(/ *\([^)]*\) */g, "").trim()
            
        });
         

    getCampaignAPICallData(userAccessObj,"getStreetsForMLCVoters")
        .then((res) => res.json())
        .then((data) => { 
          if(data !=null && data.length>0){
            this.setState({MLC_StreetNames:data,streetCheckLoader:0,streetCheckMessage:0});
          }else{
              this.setState({MLC_StreetNames:[],streetCheckLoader:0,streetCheckMessage:1});
          }
            
         });
  }

  
 

  handleOnchangeSelectBoxForMandal = (e,type) => {
    this.setState({MLCVotersListData:[],MLCVotersListCheck:0,MLCVotersListCheckLoderSymbol:"hide",
    votersListCheck:0,streetCheckMessage:0,validateReason:"",validateReasonForVillage:""});

    const name = e.target.name;
    const value = e.target.value;
    var index = e.target.selectedIndex;

    if(type == "mandal"){
      this.setState({ mandalId: value });
      setTimeout(() => {
        var mandalNameSplit = e.target[index].text.split(" ");
        if(mandalNameSplit[1] == "Town"){
          this.setState({ MandalView_locationScopeId: 7 });
          this.getVillagesForMLCVoters(7,value);
        }else{
          this.setState({ MandalView_locationScopeId: 5});
          this.getVillagesForMLCVoters(5,value);
        }
  
        
      }, 500);

    }else if(type == "village"){
      this.setState({ villageId: value,villageName:e.target[index].text,locationSopeId:6,validateReasonForVillage:""});
      this.getStreetsForMLCVoters(5,e.target[index].text);
    }else if(type == "street"){
      this.setState({ streetId: value,streetName:e.target[index].text,locationSopeId:0,streetCheckMessage:0});
    }else if(type == "MLCBoothLocId"){
      this.setState({ MLCBoothLocId: value,MLCBoothLocName:e.target[index].text,locationSopeId:20,selectedVoterListTypeName:e.target[index].text});
    }
  }

  

  getMCLBoothLocationDts = () => {
    this.getMlcVoterDetailsForCampaignSurvey(20,this.state.MLCBoothLocId);
    this.getBoothWiseMlcVotersUpdatedStatus(this.state.MLCBoothLocId);
  }

  getBoothWiseMlcVotersUpdatedStatus = (mlcBoothId) => {
    this.setState({MLCBoothWiseSummaryListData:[]});
    const userAccessObj =  
        JSON.stringify({ 
            "mlcBoothId" :mlcBoothId
        });
         

        getAPICallData(userAccessObj,"getBoothWiseMlcVotersUpdatedStatus")
        .then((res) => res.json())
        .then((data) => { 
          

         if(data !=null && data.length>0){
          this.setState({MLCBoothWiseSummaryListData:data});
         }else{
          this.setState({MLCBoothWiseSummaryListData:[]});
         }
            
        });
  }

  getMlcVoterDetailsForCampaignSurvey = (locationScopeId,locationId) => {
    this.setState({totalVoterDetails:[],mlcBoothWiseSummaryStatusObj:{},MLCVotersListData:[],MLCVotersListCheck:1,MLCVotersListCheckLoderSymbol:"show",votersListCheck:0,voterDateBlockShow:true});
    const userAccessObj =  
        JSON.stringify({ 
            "chatId" :window.User !=undefined ? window.User.chatID : "943827154",
            "campaignId" : this.state.event.campaignId,
            "locationScopeId" : locationScopeId,
            "locationId" : locationId,
            "status" : this.state.statusTypeVoter
            
        });
         

    getCampaignAPICallData(userAccessObj,"getMlcVoterDetailsForCampaignSurvey")
        .then((res) => res.json())
        .then((data) => { 
          
          this.setState({MLCVotersListCheck:0,MLCVotersListCheckLoderSymbol:"hide"});

         if(data !=null && data.length>0){
          
          const updatedStatusCount = data.filter(item => item.isD2d1Visited == "Y");
          var obj={"totalVoters":data.length,"updatedCount":updatedStatusCount.length}

          this.setState({mlcBoothWiseSummaryStatusObj:obj});

          this.setState({MLCVotersListData:data,votersListCheck:0,totalVoterDetails:data});
         }else{
          this.setState({MLCVotersListData:[],votersListCheck:1,totalVoterDetails:[]});
         }
            
        });
  }

  getMLCVotersForMandalView = () => {
    this.setState({validateReason:"" });

      if(this.state.mandalId == ""){
        this.setState({validateReason:"Please Select Mandal" });
        return;
      }
      else if(this.state.villageId == ""){
        this.setState({validateReasonForVillage:"Please Select Village" });
        return;
      }

      this.getMlcVoterDetailsForCampaignSurveyForMandalView();
  }

  
  getMlcVoterDetailsForCampaignSurveyForMandalView = () => {
    this.setState({totalVoterDetails:[],mlcBoothWiseSummaryStatusObj:{},MLCVotersListData:[],MLCVotersListCheck:1,MLCVotersListCheckLoderSymbol:"show",votersListCheck:0,voterDateBlockShow:true});

    let userAccessObj;

    if(this.state.locationSopeId == 6){
        if(this.state.MandalView_locationScopeId == 5){
          userAccessObj =  
            JSON.stringify({ 
                "chatId" : window.User !=undefined ? window.User.chatID : "943827154",
                "campaignId" : this.state.event.campaignId,
                "locationScopeId" : 6,
                "tehsilId" : this.state.mandalId,
                "village" : this.state.villageName.replace(/ *\([^)]*\) */g, "").trim(),
                "status" : this.state.statusTypeVoter
                
                
            });
      }else if(this.state.MandalView_locationScopeId == 7){
          userAccessObj =  
            JSON.stringify({ 
              "chatId" : window.User !=undefined ? window.User.chatID : "943827154",
              "campaignId" : this.state.event.campaignId,
              "locationScopeId" : 6,
              "townId" : this.state.mandalId,
              "village" : this.state.villageName.replace(/ *\([^)]*\) */g, "").trim(),
              "status" : this.state.statusTypeVoter
                
            });
      }
    }else{
        if(this.state.MandalView_locationScopeId == 5){
          userAccessObj =  
            JSON.stringify({ 
                "chatId" : window.User !=undefined ? window.User.chatID : "943827154",
                "campaignId" : this.state.event.campaignId,
                "locationScopeId" : 0,
                "tehsilId" : this.state.mandalId,
                "village" : this.state.villageName.replace(/ *\([^)]*\) */g, "").trim(),
                "streetName" :this.state.streetName.replace(/ *\([^)]*\) */g, "").trim(),
                "status" : this.state.statusTypeVoter
                
                
            });
      }else if(this.state.MandalView_locationScopeId == 7){
          userAccessObj =  
            JSON.stringify({ 
              "chatId" : window.User !=undefined ? window.User.chatID : "943827154",
              "campaignId" : this.state.event.campaignId,
              "locationScopeId" : 0,
              "townId" : this.state.mandalId,
              "village" : this.state.villageName.replace(/ *\([^)]*\) */g, "").trim(),
              "streetName" : this.state.streetName.replace(/ *\([^)]*\) */g, "").trim(),
              "status" : this.state.statusTypeVoter
                
            });
      }
    }
    
 

    getCampaignAPICallData(userAccessObj,"getMlcVoterDetailsForCampaignSurvey")
        .then((res) => res.json())
        .then((data) => { 
          
          this.setState({MLCVotersListCheck:0,MLCVotersListCheckLoderSymbol:"hide"});

         if(data !=null && data.length>0){
          const updatedStatusCount = data.filter(item => item.isD2d1Visited == "Y");
          var obj={"totalVoters":data.length,"updatedCount":updatedStatusCount.length}

          this.setState({mlcBoothWiseSummaryStatusObj:obj});
          this.setState({MLCVotersListData:data,votersListCheck:0,totalVoterDetails:data});
         }else{
          this.setState({MLCVotersListData:[],votersListCheck:1,totalVoterDetails:[]});
         }
            
        });
  }

  actionsFormatterForMLCVoterNameAndMobileNoBind = (cell, row, rowIndex, formatExtraData) => {

  
    return (
        <span style={{textAlign:"left",marginLeft:"0px"}}>{(row.VoterName)} 
        {
          row.relativeName != "" ?
          (<><br/><span className='f-10 color_red' style={{textAlign:"left",marginLeft:"0px"}}>Rel Name - {(row.relativeName)}</span></>)
          :
          ("")
        }
        {
          row.MobileNo != "" ?
          (<><br/><span className='f-10 color_red' style={{textAlign:"left",marginLeft:"0px"}}>MNo - {(row.MobileNo)}</span></>)
          :
          ("")
        }
        {
          row.casteName != "" ?
          (<><br/><span className='f-10 color_red' style={{textAlign:"left",marginLeft:"0px"}}>Caste - {(row.casteName)}</span></>)
          :
          ("")
        }

       
       
            
            

            
        </span>
     );
    
}
MLCvotersDataColumnsSingleBoothAccess() {

  let columns = [
        {
          dataField: "serialNo",
          text: "SNO",
          sort: true,
          headerStyle: {
            width: "10%"
        }
          
      },
      {
          dataField: "VoterName",
          text: "Voter Name",
          sort: true,
          formatter: this.actionsFormatterForMLCVoterNameAndMobileNoBind.bind(this),
          headerStyle: {
            width: "50%"
        }
          
      },
      {
          dataField: "Gender",
          text: "G / Age",
          sort: true,
          headerStyle: {
            width: "10%"
        }
          
      },
      /*{
          dataField: "MobileNo",
          text: "Mobile No",
          sort: true,
         
      },*/
      
      
      
      
  ];
  return columns;
}


  MLCvotersDataColumns() {

    let columns = [
          {
            dataField: "serialNo",
            text: "SNO",
            sort: true,
            headerStyle: {
              width: "10%"
          }
            
        },
        {
            dataField: "VoterName",
            text: "Voter Name",
            sort: true,
            formatter: this.actionsFormatterForMLCVoterNameAndMobileNoBind.bind(this),
            headerStyle: {
              width: "50%"
          }
            
        },
        {
            dataField: "Gender",
            text: "G / Age",
            sort: true,
            headerStyle: {
              width: "10%"
          }
            
        },
        /*{
            dataField: "MobileNo",
            text: "Mobile No",
            sort: true,
           
        },*/
        {
          dataField: "Action",
          text: "Update Voter",
          formatter: this.actionsFormatterForVoter.bind(this),
          headerStyle: {
            width: "20%"
        }
      },
        
        
        
    ];
    return columns;
}

actionsFormatterForVoter = (cell, row, rowIndex, formatExtraData) => {
  return (
    <>
      <Row>
        <Col sm={12}>
          <div className='flex_block_MLC'>
              {/*<OverlayTrigger key={"top"} placement={"top"}
                  overlay={
                    <Tooltip id={`tooltio-link-add-new-voter`}>
                      <h6 className='f-14'>Visit Voter</h6>
                    </Tooltip>
                  }
                >
                  <>
                  {
                    row.status == 'N' ?
                    (<i class="fa-solid fa-eye color_red cursor_pointer f-14" onClick={(e) => this.insertCampaignVoterSurvey(e,row.voterId)}></i>)
                    :
                    (<i class="f-14 fa-solid fa-circle-check color_green"></i>)
                  }
                  
                  </>
              </OverlayTrigger>*/}
              <OverlayTrigger key={"top"} placement={"top"}
                overlay={
                  <Tooltip id={`tooltio-link-add-new-voter`}>
                    <h6 className='f-14'>Update Voter</h6>
                  </Tooltip>
                }
              >
                {
                  row.d2d1Visited == 'N' ?
                  (<i class="fa-solid fa-circle-info cursor_pointer f-14" onClick={(e) => this.updateMLCVoterDetails(e,row.voterId)}></i>)
                  :
                  (<i class="fa-solid fa-circle-info color_green cursor_pointer f-14" onClick={(e) => this.updateMLCVoterDetails(e,row.voterId)}></i>)
                }
                
                </OverlayTrigger>
          </div>
        </Col>
        
      </Row>
     
       
      </>
  );
  
}

MLCvotersData = (dataArr) => {
  let MLCVotersDataArr = [];
      if(dataArr.length>0){
          for (let i = 0; i < dataArr.length; i++) {
              const obj = {
                serialNo:dataArr[i].serialNo,
                VoterName: dataArr[i].voterName,
                Gender: dataArr[i].gender+"/"+dataArr[i].age,
                MobileNo: dataArr[i].mobileNo,
                voterId: dataArr[i].voterId,
                status: dataArr[i].status,
                isUpdated: dataArr[i].isUpdated,
                relativeName:dataArr[i].relativeName,
                casteName:dataArr[i].casteName,
                voterSlipGiven:dataArr[i].voterSlipGiven,
                d2d1Visited:dataArr[i].isD2d1Visited	
              }
              MLCVotersDataArr.push(obj);
          } 

          
          
          return MLCVotersDataArr;
      }
}

insertCampaignVoterSurvey = (e,voter_id) => {
  var voterIdString = voter_id.toString();
  this.setState({visitedVoterLoadingSymbol:"show",visitedSelectedVoterId:voterIdString,visitLoaderSymbol:"show"});
  
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition( position => {
         const getCoordinates =  
          { 
            "latitude" : position.coords.latitude,
            "longitude" : position.coords.longitude,
          }

          const userAccessObj =  
            JSON.stringify({ 
                "chatId" :window.User !=undefined ? window.User.chatID : "943827154",
                "voterId" : parseInt(voterIdString),
                "campaignId" : this.state.event.campaignId,
                "latitude" : getCoordinates.latitude,
                "longitude":getCoordinates.longitude
                
            });
            

        getCampaignAPICallData(userAccessObj,"insertCampaignVoterSurvey")
            .then((res) => res.json())
            .then((data) => { 
              this.setState({visitedVoterLoadingSymbol:"hide",visitLoaderSymbol:"hide"});
              if(data !=null && data.status == "Success"){
                this.setState({visitedMessageDisplay:"Visited SuccessFully..."});
                setTimeout(() => {
                  let new_updated_data = this.state.MLCVotersListData.map((item) => {
                      if (item.voterId == voterIdString) {
                          return {
                              ...item,
                              status: "Y",
                          };
                      }
                      return item;
                  });
                  this.setState({MLCVotersListData:new_updated_data,visitedMessageDisplay:""})
              }, 1000);

                /*setTimeout(() => {
                  if(this.state.MLCvoterType == "CUBS"){
                    this.getMlcVoterDetailsForCampaignSurvey(this.state.cubsLocationScopeId,this.state.cubsLocationId);
                  }else{
                    this.getMlcVoterDetailsForCampaignSurveyForMandalView();
                  }
                  
                  this.setState({visitedMessageDisplay:""});
              }, 1000);*/
              }else{
                this.setState({visitedMessageDisplay:"Some Thing Wrong,Please Check once"});
              }
                
            });

      });
    }

 
}


/*updateMLCVoterDetails = async (e,voter_id) => {
  this.setState({getCurrentLocationCoordinates:{},locationStatus: "Checking Mobile Location Is Enabled or Disabled..."});
  this.setState({updateMLCVoterAttributesModal:true});
  this.setState({updateVoterDetails:{}});

  if (!navigator.geolocation) {
    this.setState({ locationStatus: "Geolocation is not supported by your browser." });
    return;
  }

  try {
    // Step 1: Check permission status
    if (navigator.permissions) {
      const permission = await navigator.permissions.query({ name: "geolocation" });

      if (permission.state === "denied") {
        this.setState({ locationStatus: "Location is OFF ❌ (Permission Denied). Enable location services." });
        return;
      }
    }

    // Step 2: Set a timeout to detect if location is OFF (e.g., GPS disabled)
    this.locationTimeout = setTimeout(() => {
      this.setState({ locationStatus: "Location is OFF ❌ (GPS Disabled). Please turn it ON." });
    }, 5000); // Timeout after 5 seconds if no response

    // Step 3: Request location
    navigator.geolocation.getCurrentPosition(
      (position) => {
        clearTimeout(this.locationTimeout); // Clear timeout if we get a response
        /*this.setState({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          locationStatus: "Location is ON ✅",
        });

        const getCoordinates =  
          { 
            "latitude" : position.coords.latitude,
            "longitude" : position.coords.longitude,
            "accuracy":position.coords.accuracy
          }
          
        this.setState({getCurrentLocationCoordinates:getCoordinates,locationStatus: "Location is ON"});

        this.getMlcVoterAttributeDetails(voter_id);

      },
      (error) => {
        clearTimeout(this.locationTimeout); // Clear timeout since we got an error

        let errorMessage = "An unknown error occurred.";
        switch (error.code) {
          case error.PERMISSION_DENIED:
            errorMessage = "Location is OFF ❌ (Access Denied). Please enable location services.";
            break;
          case error.POSITION_UNAVAILABLE:
            errorMessage = "Location is OFF ❌ (Position Unavailable). Turn on GPS.";
            break;
          case error.TIMEOUT:
            errorMessage = "Error: The request to get user location timed out.";
            break;
          default:
            break;
        }
        this.setState({ locationStatus: errorMessage });
      },
      { timeout: 5000 } // Ensure the request times out if it hangs
    );
  } catch (error) {
    this.setState({ locationStatus: "Error checking location status." });
  }
};*/




updateMLCVoterDetails = (e,voter_id) => {
  //this.setState({getCurrentLocationCoordinates:{}});
  this.setState({updateVoterDetails:{}});
  this.setState({updateMLCVoterAttributesModal:true});

  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition( (position) => {
       var getCoordinates =  
      { 
        "latitude" : position.coords.latitude,
        "longitude" : position.coords.longitude,
        "accuracy":position.coords.accuracy
      }
      
      this.setState({getCurrentLocationCoordinates:getCoordinates});
    });
}

 setTimeout(() => {
   // navigator.geolocation.getCurrentPosition(this.showLocationMLCCPostions,this.ShowLocationPermissionError)
    this.getMlcVoterAttributeDetails(voter_id);
 }, 2000);
  
}

showLocationMLCCPostions = (position) => {
  const getCoordinates =  
      { 
        "latitude" : position.coords.latitude,
        "longitude" : position.coords.longitude,
        "accuracy":position.coords.accuracy
      }
      
  this.setState({getCurrentLocationCoordinates:getCoordinates});
}

ShowLocationPermissionError = (error) => {
  switch (error.code){
      case error.PERMISSION_DENIED:
        alert("User Location Permission is Denied,Please Enable Location Services...(Path:Settings > Privacy > Location Services)");
        break;

        case error.POSITION_UNAVAILABLE:
        alert("User Postion Unavailable Denied");
        break;

        default:
          alert("An unknown error occurred")
  }
}

getMlcVoterAttributeDetails = (voter_id) => {
  const userAccessObj =  
      JSON.stringify({ 
          "chatId" :window.User !=undefined ? window.User.chatID : "943827154",
          "voterId":voter_id.toString(),
      });
       

  getCampaignAPICallData(userAccessObj,"getMlcVoterAttributeDetails")
      .then((res) => res.json())
      .then((data) => { 
        
        if(data !=null){
          this.setState({updateVoterDetails:data});
          setTimeout(() => {
            if(data !=""){
              this.setState({updateVoterCardNo:data.voterCardNo});
              this.setState({mobileNo:data.mobileNo});
              this.setState({caste:data.casteStateId});
              this.setState({searchValue:data.caste})
              this.setState({party:data.partyId});
              this.setState({voterStatus:data.voterStatusId});
              this.setState({d2d1VisitedStateValue:data.d2d1Visited});
              this.setState({residenceStatusValue:data.livingStatusId});
              this.setState({voterResidenceAddressVal:data.livingAddress});
              this.setState({checkNexttimeUpdate:data.d2d1Visited})
             // this.setState({voterSlipGiven:data.voterSlipGiven});
            }
            
          }, 500);
          
        }else{
          this.setState({updateVoterDetails:{}});
        }  
       });
}

handleOnchangeSetUpdateVoterDts = (e,type) => {
  const name = e.target.name;
  const value = e.target.value;

  this.setState({ [name]: value });
}




UpdateMlcVoterAttributes = (e,voter_id) => {
  console.log("new_updated_dataeee22e",this.state.MLCVotersListData)
  this.setState({validateResidenceStatusValue:"", validateVerResidenceAddressVal:""})

  this.setState({validateUpdateVoterCardNo:"",validateUpdateTransportStatus:"",validateUpdateCaste:"",validateUpdateParty:"",validateUpdateMobileNo:"",validateUpdateVoterStatus:"",validateUpdateD2d1VisitedStateValue:""})
  console.log(this.state.updateVoterCardNo)
  console.log(this.state.transportStatus)
  console.log(this.state.caste)
  console.log(this.state.party)
  console.log(this.state.mobileNo)

  

    
  /*if(this.state.updateVoterCardNo == ""){
      this.setState({validateUpdateVoterCardNo:"Please Enter Voter Card No" });
      return;
  }

 
  if(this.state.updateVoterCardNo.match(' ')){
    this.setState({validateUpdateVoterCardNo:"Please Enter Valid Voter Card No(remove space)" });
    return;
  }

  if(this.state.updateVoterCardNo.length <=9){
    this.setState({validateUpdateVoterCardNo:"Please Enter Valid Voter Card No" });
    return;
  }

  /*if(this.state.transportStatus == ""){
    this.setState({validateUpdateTransportStatus:"Please Select Transport Status" });
    return;
  }
  
if(this.state.caste == ""){
    this.setState({validateUpdateCaste:"Please Select Caste" });
    return;
}
if(this.state.party == "" || this.state.party == 0){
  this.setState({validateUpdateCaste:"Please Select Party" });
  return;
}

if(this.state.mobileNo == ""){
  this.setState({validateUpdateMobileNo:"Please Enter Mobile No" });
  return;
}

if(!this.state.mobileNo.match(/^[0-9]+$/)){
  this.setState({validateUpdateMobileNo:"Please Enter Valid Mobile No" });
  return;
}

if(this.state.voterStatus == "" || this.state.voterStatus == 0){
  this.setState({validateUpdateVoterStatus:"Please Select Voter Status" });
  return;
}*/

if(this.state.mobileNo == ""){
  this.setState({validateUpdateMobileNo:"Please Enter Mobile No" });
  return;
}

if(!this.state.mobileNo.match(/^[0-9]+$/)){
  this.setState({validateUpdateMobileNo:"Please Enter Valid Mobile No" });
  return;
}

if(this.state.mobileNo.length < 10){
  this.setState({validateUpdateMobileNo:"Please Enter 10 Digist Mobile No" });
  return;
}

if(this.state.mobileNo == "0000000000"){
  this.setState({validateUpdateMobileNo:"Please Enter Valid Mobile No" });
  return;
}


  
if(this.state.d2d1VisitedStateValue == "" || this.state.d2d1VisitedStateValue == 0){
  this.setState({validateUpdateD2d1VisitedStateValue:"Please Select Status" });
  return;
}


if(this.state.residenceStatusValue == 2){
  if(this.state.voterResidenceAddressVal == ""){
    this.setState({validateVerResidenceAddressVal:"Please Enter Address" });
    return;
  }
  
}

this.setState({updateMLCDTDAttriLoadingSymbol:"show"})

console.log("this.updateVoterDetails.d2d1Visited",this.state.getCurrentLocationCoordinates)
  const addNewVoterObj =  
    JSON.stringify({ 
      "chatId" :window.User !=undefined ? window.User.chatID : "943827154",
      "voterId" : voter_id,
      "mobileNo" :this.state.mobileNo,
      "casteStateId" : this.state.caste,
      "transportTypeId" : this.state.transportStatus,
      "partyId" : this.state.party,
      "voterCardNo":this.state.updateVoterCardNo,
      "d2d1Visited":this.state.checkNexttimeUpdate == 'Y' ? null : this.state.d2d1VisitedStateValue,
      "actionName":"D2D1",
      "latitude" : this.state.getCurrentLocationCoordinates.latitude == undefined ? "" : this.state.getCurrentLocationCoordinates?.latitude.toString(),
      "longitude" : this.state.getCurrentLocationCoordinates.longitude == undefined ? "" : this.state.getCurrentLocationCoordinates?.longitude.toString(),
      "livingStatusId":this.state.residenceStatusValue,
      "livingAddress":this.state.voterResidenceAddressVal,
      

    }
  ); 

  

  //addNewVoter
  getCampaignAPICallData(addNewVoterObj,"updateMlcVoterAttributes")
      .then((res) => res.json())
      .then(async(data) => {
        this.setState({updateMLCDTDAttriLoadingSymbol:"hide"})
        if(data !=null){
          if(data.status == "Success"){
            this.setState({newMemberAddedMsg:"Updated Voter SuccessFully..." });
           
            setTimeout(() => {
              this.setState({newMemberAddedMsg:"",updateMLCVoterAttributesModal:false,validateUpdateVoterCardNo:"",validateUpdateTransportStatus:"",validateUpdateCaste:"",validateUpdateParty:"",validateUpdateMobileNo:"",validateUpdateVoterStatus:""})
              this.setState({updateVoterCardNo:"",transportStatus:"",caste:"",party:"",mobileNo:""})
              
              //this.setState({MLCVotersListData:new_updated_data});
              this.setState(prevState => ({
                totalVoterDetails: prevState.totalVoterDetails.map(user =>
                  user.voterId == voter_id ? { ...user, isD2d1Visited: this.state.d2d1VisitedStateValue } : user
                )
              }));

              let new_updated_data = this.state.MLCVotersListData.map((item) => {
                if (item.voterId == voter_id) {
                    return {
                        ...item,
                        isD2d1Visited: this.state.d2d1VisitedStateValue,
                    };
                }
                return item;
            });
            this.setState({MLCVotersListData:new_updated_data})
             
            
              /*if(this.state.MLCvoterType == "CUBS"){
                this.getMlcVoterDetailsForCampaignSurvey(this.state.cubsLocationScopeId,this.state.cubsLocationId);
              }else{
                this.getMlcVoterDetailsForCampaignSurveyForMandalView();
              }*/
          }, 1000);

          setTimeout(() => {
            console.log("new_updated_dataeeee",this.state.totalVoterDetails)
            const updatedStatusCount = this.state.totalVoterDetails.filter(item => item.isD2d1Visited == "Y");
            console.log("new_updated_dataeeeeUPPP",updatedStatusCount)
            var obj={"totalVoters":this.state.totalVoterDetails.length,"updatedCount":updatedStatusCount.length}

            this.setState({mlcBoothWiseSummaryStatusObj:obj});

          }, 2500);
          
          }else if(data.status == "Fail"){
            if(data.message == "Invalid Inputs"){
              this.setState({newMemberAddedMsg:"Please Enter Valid Inputs...." });
            }else{
              this.setState({newMemberAddedMsg:data.message });
            }
            
          }
        }else{
          this.setState({newMemberAddedMsg:"Something Wrong,Please Try Again..." });
        }
       
        
        
  });
  
}

handlesearchVoterDataValue = (event) => {
  this.setState({
    searchVoterDataValue: event.target.value
  })
}

votersDataFilterWiseDetails = (e,statusType) => {
  var usersArr = this.state.totalVoterDetails;

  console.log("ssssss",statusType)

  if(statusType == ""){
    setTimeout(() => {
      this.setState({MLCVotersListData:usersArr})
    }, 800);
    
    
  }else if(statusType == "Y"){
    var updatedStatusRecords = usersArr.filter(item => item.isD2d1Visited	== "Y");
    setTimeout(() => {
      this.setState({MLCVotersListData:updatedStatusRecords})
    }, 800);
   
  }else if(statusType == "N"){
    var notupdatedStatusRecords = usersArr.filter(item => item.isD2d1Visited == "N");
    setTimeout(() => {
      this.setState({MLCVotersListData:notupdatedStatusRecords})
    }, 800);
   
  }

  console.log("MLCVotersListData",this.state.MLCVotersListData)
}

handleInputChangeCaste = (e) => {
  this.setState({ searchValue: e.target.value });
};

handleOnchangeAllowNumbersInputBox = (event) => {
  this.setState({validateUpdateMobileNo:""})
  const { value } = event.target;
  // Remove non-numeric characters
  const numericValue = value.replace(/[^0-9]/g, "");
  this.setState({ mobileNo: numericValue });
}

toggleDropdown = () => {
  this.setState((prevState) => ({ showDropdown: !prevState.showDropdown }));
};

hideDropdown = () => {
  this.setState({ showDropdown: false });
};

selectOption = (option,optionId) => {
  this.setState({ selectedOption: option, searchValue: option, showDropdown: false });
  this.setState({caste:optionId})
};  


reloadMLCPage = () => {
  this.props.history.push("/dashboard");
}

  render() {

    


    let manualSearchMLCVotersListData=[];
        let keyword = this.state.searchVoterDataValue.toString()
        if (keyword !== ''){
          manualSearchMLCVotersListData = this.state.MLCVotersListData.filter(  (item) => {
                
                
                if (item.voterName.toLowerCase().startsWith(keyword.toLowerCase())) {
                    return item;
                }
                if (item.mobileNo.toString().startsWith(keyword.toLowerCase())) {
                    return item;
                }
                if (item.gender.toString().startsWith(keyword.toLowerCase())) {
                    return item;
                }
                if (item.age.toString().startsWith(keyword.toLowerCase())) {
                    return item;
                }
                if (item.serialNo.toString().startsWith(keyword.toLowerCase())) {
                    return item;
                }
                if (item.relativeName.toLowerCase().startsWith(keyword.toLowerCase())) {
                  return item;
                }
                if (item.casteName.toLowerCase().startsWith(keyword.toLowerCase())) {
                  return item;
                }
              
                
            } );
        }else{
          manualSearchMLCVotersListData = this.state.MLCVotersListData;
            
        }
        
      return (
        <section >
         
        
         <Container>
         <Row>
                <Col>
                    <h6 className='text-center color_green fw-bold  mt-3'>DOOR TO DOOR CAMPAIGN-01 <br/> <span className='border-bottom-double'>(30 VOTERS POC V2V CAMPAIGN) </span></h6>
                </Col>
          </Row>
          {
            this.state.locationStatus == "Location is ON" ? 
            (
              <>
                {/*<Row>
                  <Col>
                      <div className='flex-box-Status'>
                          <h6 className='f-14 fw-bold mt-4'>Status : </h6>
                          <div className='mt-4'>
                            <Row>
                              <Col>
                              
                                <Form className="">
                                <Form.Check
                                      inline
                                      label="All"
                                      name="mlc_voters_block"
                                      type="radio"
                                      id="allStatusId"
                                      onChange={()=>this.selectStatusType("All",0)}
                                      className="f-14 fw-bold"
                                      value=""
                                      defaultChecked={true}
                                    />
                                    <Form.Check
                                      inline
                                      label="Visited"
                                      name="mlc_voters_block"
                                      type="radio"
                                      id="visitedStatusId"
                                      onChange={()=>this.selectStatusType("Visited",'Y')}
                                      className="f-14 fw-bold"
                                      value="Y"
                                    />
                                  
                                    <Form.Check
                                      inline
                                      label="Pending"
                                      name="mlc_voters_block"
                                      type="radio"
                                      id="pendingStatusId"
                                      onChange={()=>this.selectStatusType("Pending","N")}
                                      className="f-14 fw-bold"
                                      value="N"
                                    />
                                    
                                </Form>
                              </Col>
                            </Row>
                            
                          </div>
                      </div>
                  </Col>
                </Row>*/}
                <Row>
                  <Col sm={12} className="">
                      <div className='border_pad mt-2'>
                      <Row>
                              <Col>
                                <Form >
                                  <Form.Check
                                        inline
                                        label="MLC Booth"
                                        name="voters_type"
                                        type="radio"
                                        id="MLC_BoothId"
                                        onChange={()=>this.selectedVoterType("Mlc_booth")}
                                        className="f-14 fw-bold"
                                        value="Mlc_booth"
                                        checked={this.state.MLC_booth_boolean}
                                    />
                                    <Form.Check
                                          inline
                                          label="Mandal/Village"
                                          name="voters_type"
                                          type="radio"
                                          id="mandalViewId"
                                          onChange={()=>this.selectedVoterType("mandal")}
                                          className="f-14 fw-bold"
                                          value="mandal"
                                          checked={this.state.mandal_view_boolean}
                                        />
                                    
                                    
                                </Form>
                              </Col>
                            </Row>
                      </div>
                  </Col>
              </Row>


              {
                this.state.MLCvoterType == "mandal" ? 
                (
                  <>
                      <Row>
                        <Col className='mt-2'>
                              <label className="form-label f-13 fw-bold">Mandal 
                              {
                                  this.state.mlcBoothLocLoadingSymbol == "show" ?
                                  (<Image src={loader} alt="loader" className='loader_cls ms-2 float-end'></Image>)
                                  :
                                  ("")
                              }
                              </label>
                              <select id="mandal_id" name="mandalId" className='form-select form-select-sm' onChange={(e) => this.handleOnchangeSelectBoxForMandal(e,"mandal")}>
                                    {
                                          this.state.MLC_MandalNames.length>0  ? 
                                          (
                                              <>
                                              <option value="">Select Mandal</option>
                                              {
                                                  this.state.MLC_MandalNames.map((item,index) => {
                                                      return(
                                                        <option key={index} value={item.id} attr_name={item.name} >{item.name}</option>
                                                        
                                                      )
                                                  })
                                              }
                                              </>
                                            
                                          )
                                          :
                                          (<option value="">Select Mandal</option>)
                                          
                                      }
                              </select>
                              {
                                this.state.validateReason !="" ?
                                (<span className='f-12 color_red'>{this.state.validateReason}</span>)
                                :
                                ("")
                              }
                              
                            </Col>
                            <Col className='mt-2'>
                              <label className="form-label f-13 fw-bold">Village 
                              {
                              this.state.villageCheckLoader == 1 ?
                                (<Image src={loader} alt="loader" className='loader_cls ms-2'></Image> )
                                :
                                ("")
                              }
                              
                              </label>
                              <select id="village_id" name="villageId" className='form-select form-select-sm' onChange={(e) => this.handleOnchangeSelectBoxForMandal(e,"village")}>
                                    {
                                          this.state.MLC_VillageNames.length>0  ? 
                                          (
                                              <>
                                              <option value="">Select Village</option>
                                              {
                                                  this.state.MLC_VillageNames.map((item,index) => {
                                                      return(
                                                        <option key={index} value={item.name} > {item.name}</option>
                                                        
                                                      )
                                                  })
                                              }
                                              </>
                                            
                                          )
                                          :
                                          (<option value="">Select Village</option>)
                                          
                                      }
                              </select>
                              {
                                this.state.validateReasonForVillage !="" ?
                                (<span className='f-12 color_red'>{this.state.validateReasonForVillage}</span>)
                                :
                                ("")
                              }
                              
                            </Col>
                            </Row>

                            <Row>
                              {/*<Col className='mt-2'>
                                  <label className="form-label f-13 fw-bold">Street 
                                  {
                                    this.state.streetCheckLoader == 1 ?
                                    (<Image src={loader} alt="loader" className='loader_cls ms-2'></Image>)
                                    :
                                    ("")
                                  }
                                  
                                  </label>
                                  <select id="street_id" name="streetId" className='form-select form-select-sm' onChange={(e) => this.handleOnchangeSelectBoxForMandal(e,"street")}>
                                        {
                                              this.state.MLC_StreetNames.length>0  ? 
                                              (
                                                  <>
                                                  <option value="">Select Street</option>
                                                  {
                                                      this.state.MLC_StreetNames.map((item,index) => {
                                                          return(
                                                            <option key={index} value={item.id} > {item.name}</option>
                                                            
                                                          )
                                                      })
                                                  }
                                                  </>
                                                
                                              )
                                              :
                                              (<option value="">Select Street</option>)
                                              
                                          }
                                  </select>
                                  {
                                    this.state.streetCheckMessage == 1  ?
                                    (<span className='f-12 color_red'>No Streets Available...</span>)
                                    :
                                    ("")
                                  }
                                  
                                </Col>*/}
                                <Col>
                                    <Button type="button" className='btn btn-sm btn-success center-auto mt-4' onClick={(e) => this.getMLCVotersForMandalView(e)}>GET Voters</Button>
                                </Col>
                              
                            </Row>
                            {
                                    this.state.streetCheckMessage == 1  ?
                                    (<Row>
                                      <Col>
                                          <h6 className='f-12 mt-3'>Note : If Streets are not Available,please select village name then submit Get Voters</h6>
                                        </Col>
                                    </Row>)
                                    :
                                    ("")
                                  }
                            
                        
                      
                        </>
                )
                :
                (
                  <>
                      <Row>
                      <Col className='mt-2'>
                              <label className="form-label f-13 fw-bold">MLC Booth Location 
                              {
                                  this.state.mlcBoothLocLoadingSymbol == "show" ?
                                  (<Image src={loader} alt="loader" className='loader_cls ms-2 float-end'></Image>)
                                  :
                                  ("")
                              }
                              </label>
                              <select id="MLC_Booth_LocId" name="MLCBoothLocId" className='form-select form-select-sm' onChange={(e) => this.handleOnchangeSelectBoxForMandal(e,"MLCBoothLocId")}>
                                  {
                                          this.state.MLC_BoothLoc.length>0  ? 
                                          (
                                              <>
                                              <option value="">Select Location</option>
                                              {
                                                  this.state.MLC_BoothLoc.map((item,index) => {
                                                      return(
                                                      <option key={index} value={item.id} attr_name={item.name} >{item.name}</option>
                                                      
                                                      )
                                                  })
                                              }
                                              </>
                                          
                                          )
                                          :
                                          (<option value="">Select Location</option>)
                                          
                                      }
                              </select>
                              {
                              this.state.validateReasonMLCBoothLoc !="" ?
                              (<span className='f-12 color_red'>{this.state.validateReasonMLCBoothLoc}</span>)
                              :
                              ("")
                              }
                              
                          </Col>
                          </Row>
                          <Row>
                                <Col>
                                    <Button type="button" className='btn btn-sm btn-success center-auto mt-4' onClick={(e) => this.getMCLBoothLocationDts(e)}>GET Voters</Button>
                                </Col>
                          </Row>
                          </>
                )
              }

            
              {
                this.state.voterDateBlockShow == true ?
                (
                  <>
                    

                    <Row>
                        <Col sm={12}>
                    
                        <div className='bg_light_blue mt-3'>
                                {
                                    this.state.MLCVotersListCheckLoderSymbol == "show" && this.state.MLCVotersListData.length == 0  ?
                                    (
                                        <Row>
                                            <Col sm={12}>
                                                <div class="spinner-border color_yellow loading-img-center mt-4"></div>
                                            </Col>
                                        </Row>
                                    )
                                    :
                                    ("")
                                }
                                <Row>
                                    <Col sm={6}>
                                        <input
                                            className='float-end search_bar mt-2'
                                            type="search"
                                            placeholder='Search'
                                            value={this.state.searchVoterDataValue}
                                            onChange={this.handlesearchVoterDataValue}
                                        />
                                        <i className='fa fa-search search-icon'></i>
                                    </Col>
                                </Row>

                                <>
                                    {
                                        manualSearchMLCVotersListData.length>0 ?
                                        (
                                            
                                        
                                          <Row>
                                            <Col sm={12}>
                                            <h6 className='f-14 mt-3'>
                                                Note : {/*<span className='ml_5 mr_2'><i class="fa-solid fa-eye color_red f-14"></i> Visit Voter,</span>*/}
                                                        <span className='ml_5 mr_2'><i class="fa-solid fa-circle-info  f-14"></i> Voter Update</span>
                                                        {/*<span className='ml_5 mr_2'><i class="f-14 fa-solid fa-circle-check color_green"></i> Visited</span>*/}
                                                        <span className='ml_5 mr_2 mt-2'><i class="fa-solid fa-circle-info color_green  f-14"></i> Updated Voter</span>
                                            </h6>
                                            </Col>
                                            <Col sm={12}>
                                                <div className='bg_light_blue mt-1'>
                                                    <h6 className='f-14'> {this.state.selectedVoterListTypeName} MLC Voter Details : 
                                                    {
                                                      this.state.visitedMessageDisplay != "" ?
                                                      (<span className='f-12 color_green fw-bold mt-2 mb-2'>{this.state.visitedMessageDisplay}</span>)
                                                      :
                                                      ("")
                                                    }
                                                    </h6>
                                                    
                                                    <Row>
                                                      <Col>
                                                        <h6 className='f-14 mt-3'> D2D1 Visited  Status Summary : </h6>
                                                        <table className='table table_custom table-bordered'>
                                                          <thead>
                                                              <tr>
                                                                <th>Total Voters</th>
                                                                <th>Updated</th>
                                                                <th>Not Updated</th>
                                                              </tr>
                                                          </thead>
                                                          <tbody>
                                                              <tr>
                                                                <td className="cursor_pointer text-decoration-underline color_anchor" onClick={(e) => this.votersDataFilterWiseDetails(e,"")}>{this.state.mlcBoothWiseSummaryStatusObj.totalVoters}</td>
                                                                <td className="cursor_pointer text-decoration-underline color_anchor" onClick={(e) => this.votersDataFilterWiseDetails(e,"Y")}>{this.state.mlcBoothWiseSummaryStatusObj.updatedCount}</td>
                                                                <td className="cursor_pointer text-decoration-underline color_anchor" onClick={(e) => this.votersDataFilterWiseDetails(e,"N")}>{this.state.mlcBoothWiseSummaryStatusObj.totalVoters - this.state.mlcBoothWiseSummaryStatusObj.updatedCount}</td>
                                                              </tr>
                                                          </tbody>
                                                        </table>
                                                      </Col>
                                                    </Row>
                                                    
                                                    {
                                                      this.state.MLCvoterType == "mandal" &&  this.state.mlcBoothAccessChecking == true ?
                                                      (
                                                        <CardLessDataTableWithOutSearch 
                                                          parentData={this.MLCvotersData(manualSearchMLCVotersListData)}
                                                          particlecolumns={this.MLCvotersDataColumns()}
                                                          defaultSorted={[{
                                                              dataField: "VoterName",
                                                              order: "desc"
                                                          }]}
                                                          tableHeading=""
                                                          />
                                                      )
                                                      :
                                                      (
                                                        <CardLessDataTableWithOutSearch 
                                                          parentData={this.MLCvotersData(manualSearchMLCVotersListData)}
                                                          particlecolumns={this.MLCvotersDataColumns()}
                                                          defaultSorted={[{
                                                              dataField: "VoterName",
                                                              order: "desc"
                                                          }]}
                                                          tableHeading=""
                                                          />
                                                      )
                                                    }
                                                    
                                                    
                                                </div>     
                                            </Col> 

                                                

                                      </Row>
                                                            
                                                                
                                            
                                        )
                                        :
                                        (<>
                                            {
                                            this.state.votersListCheck == 1 ?
                                            (<h6 className='f-14 text-center mt-4'>No Voters Available...</h6>)
                                            :
                                            ("")
                                        }
                                        </>)
                                        }
                                    </>

                                    
                            </div>
                                                    
                        </Col>
                    </Row>
                    </>
                )
                :
                ("")
              }
              </>
            )
            :
            (
              <>
                {
                    this.state.locationStatus == "The request to get user location timed out,Please Close The BOT Then Reopen..." ?
                    (
                      <>
                        <h6 className='text-center color_red mt-3'>{this.state.locationStatus}</h6>

                        <h6 className='text-center color_red mt-2'>(or)</h6>

                        <Button type="button" variant="outline-danger" className='fw-bold f-14 center-auto mt-3' onClick={(e) => this.reloadMLCPage(e)}>RELOAD</Button>
                      </>
                    )
                    :
                    (
                      <>
                        <Row>
                            <Col sm={12}>
                                <div class="spinner-border color_yellow loading-img-center mt-4"></div>
                            </Col>
                        </Row>

                      <h6 className='text-center color_red mt-3'>{this.state.locationStatus}</h6>
                    </>
                    )
                  }
                </>
            )
          }
          
        

          <UpdateMLCD2D1VisitedAttributesSavingModal
                show={this.state.updateMLCVoterAttributesModal}
                onHide={() => this.setState({ updateMLCVoterAttributesModal: false })}
                stateData = {this.state}
                phandleOnchangeSetUpdateVoterDts={this.handleOnchangeSetUpdateVoterDts}
                pUpdateMlcVoterAttributes={this.UpdateMlcVoterAttributes}
                handleInputChangeCaste={this.handleInputChangeCaste}
                toggleDropdown={this.toggleDropdown}
                selectOption={this.selectOption}
                hideDropdown={this.hideDropdown}
                handleOnchangeAllowNumbersInputBox={this.handleOnchangeAllowNumbersInputBox}
            />
        
        </Container>
        </section>
      )
  }
}

export default (MLCVotersD2D1Visited);
